module.exports = __webpack_public_path__ + "static/media/raychem-catalog-ru.ddfa344d.pdf";